import axios from 'axios';

let prefix = "/stat-definitions"

const StatDefinitionApi = {
	listStatDefinitions() {
		return axios.get(prefix + "/")
	},
	createStatDef(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateStatDef(payload) {
		return axios.post(prefix + "/update", payload)
	},
	deleteStatDef(payload) {
		return axios.delete(prefix + "/delete", { data: payload })
	},
}

export default StatDefinitionApi;
